import { useNavigationDelay, ActiveItem } from './useNavigationDelay';
import { getEmptyActiveRow } from '../getEmptyActiveRow';
import { ActiveRowInfo } from '../types';

const MAX_MENU_LEVELS = 4;

export const useNavigationDelayByLevel = (
  level: number,
  setActiveRowsByIndex: (rows: Record<number, ActiveRowInfo>) => void
) => {
  const getActiveRows = (activeItem: ActiveItem) =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
    [...Array(MAX_MENU_LEVELS - level)].reduce((prev, _, currentIndex) => {
      const index = level + currentIndex;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return { ...prev, [index]: currentIndex === 0 ? activeItem : getEmptyActiveRow() };
    }, {});

  return useNavigationDelay({
    onItemActivated: (activeItem) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      setActiveRowsByIndex(getActiveRows(activeItem));
    },
  });
};
